<template lang='pug'>
.base(:class="theme")
  CursorCustom(:theme="theme")
  BaseView(
    :scroll="true",
    :theme="theme",
    :orientation="orientation",
    :scrollbar="scrollbar",
    appear="normal"
  )
    .layers
      .layer.f-layer(data-layer="1")
        h1.f-title
          span C
          span H
          span R
          span Y
          span S
          span L
          span E
          span R
        .f-subtitle
          span B
          span u
          span i
          span l
          span d
          span i
          span n
          span g
        .layer__bg
          BuildingSVG
      .layer(
        v-for="layer in layers",
        :key="layer.id",
        :data-layer="layer.id",
        :style="{ 'background-image': `url(${layer.src})` }"
      )
    .main(
      ref="container",
      :style="{ transform: `${move}`}",
      @wheel="clearLayers"
    )
      .main-block.layer-trigger
      .main-block.horizontal-content.horizontal-content-1(ref='new-york')
        Roller(:count="12", :type="1")
        .main-block__content
          .main-block__title
            .title-3.title.title-observe.observe
              span N
              span E
              span W
              span &nbsp
              span Y
              span O
              span R
              span K
            .title-3.title.title-observe.observe
              span L
              span E
              span G
              span E
              span N
              span D

          .description.observe
            span.count 001
            .description__part
              .p-1.text.text-observe
                p One of the most recognizable skyscrapers of New York City shaping that iconic
                p Manhattan skyline, the Chrysler Building, has been epitomizing New York City
                p since the Roaring Twenties. The great Art Deco masterpiece became
                p the first man-made structure to exceed 1,000 feet. For a few months
                p it was the tallest building in the world, and it still remains
                p the world’s tallest brick building. Its extraordinary
                p stainless steel spire reaching up to the sun is
                p the symbol of progress rising above New York City.

              .p-1.text.mobile One of the most recognizable skyscrapers of New York City shaping that iconic Manhattan skyline, the Chrysler Building, has been epitomizing New York City since the Roaring Twenties. The great Art Deco masterpiece became the first man-made structure to exceed 1,000 feet. For a few months it was the tallest building in the world, and it still remains the world’s tallest brick building. Its extraordinary stainless steel spire reaching up to the sun is the symbol of progress rising above New York City.

        .horizontal-content__pics
          .pic__item.border-pic.observe
            .picture
              img(src="./pics/part-1/part-1-1.webp")
          .pic__item.dop-pic.observe
            .picture
              img(src="./pics/part-1/part-1-2.webp")

      .main-block.layer-trigger.observe.trigger-1(
        data-trigger="1",
        data-lax-preset="lazy-200"
      )
      .main-block.horizontal-content.horizontal-content-2(ref='architecture')
        .main-block__content

          h2.title-5.title.text-case-normal The ambitious project of a Brooklyn-born architect William Van Alen generously sponsored by an industrialist Walter P. Chrysler materialized in an ode to the machine age and to the power of American industry.
          .description__area
            .description.observe
              .description__part
                .p-1.text.text-observe
                  p The shape of the building was largely determined by the Zoning Resolution,
                  p which intended to prevent skyscrapers from blocking light for streets and
                  p smaller buildings. So buildings were required to taper off as they were
                  p getting higher. Each setback of the Chrysler Building has its own
                  p peculiarities. Smooth black granite covers the first floor exterior;
                  p white marble dominates the next three floors. Ornament of white brick
                  p combined with white marble strands is covering the floors from 4 to 16.
                  p The higher we go, the more decorative elements appear on the façade,
                  p and up to the 24th floor strict symmetric patterns of brick and marble
                  p are getting accompanied by abstract reliefs. The 4th setback is
                  p ornamented with zigzags of dark bricks. The main tower is decorated
                  p with Mercury winged helmet hood ornaments and gargoyles imitating
                  p famous company's radiator caps on the 31st and 61st floors.

                .p-1.text.mobile The shape of the building was largely determined by the Zoning Resolution, which intended to prevent skyscrapers from blocking light for streets and smaller buildings. So buildings were required to taper off as they were getting higher. Each setback of the Chrysler Building has its own peculiarities. Smooth black granite covers the first floor exterior; white marble dominates the next three floors. Ornament of white brick combined with white marble strands is covering the floors from 4 to 16. The higher we go, the more decorative elements appear on the façade, and up to the 24th floor strict symmetric patterns of brick and marble are getting accompanied by abstract reliefs. The 4th setback is ornamented with zigzags of dark bricks. The main tower is decorated with Mercury winged helmet hood ornaments and gargoyles imitating famous company's radiator caps on the 31st and 61st floors.
            .description.observe
              .description__part
                .p-1.text.text-observe
                  p And like in ancient layered ziggurats, gods were believed to live at the top, the
                  p iconic terraced crown and silver spike of Chrysler Building embodied wealth
                  p and power as the new deities of the era. Seven steel-layered arches with
                  p triangle windows light up the path for the 185-feet spire. Five sections of it
                  p were secretly transported inside the building so the competitors in the race
                  p for the erecting the highest building in the city could not see the plan.
                  p It took only 90 minutes to hoist the spectacular spire on the crown
                  p and to make New York City look up and marvel.
                .p-1.text.mobile And like in ancient layered ziggurats, gods were believed to live at the top, the iconic terraced crown and silver spike of Chrysler Building embodied wealth and power as the new deities of the era. Seven steel-layered arches with triangle windows light up the path for the 185-feet spire. Five sections of it were secretly transported inside the building so the competitors in the race for the erecting the highest building in the city could not see the plan. It took only 90 minutes to hoist the spectacular spire on the crown and to make New York City look up and marvel.
        .pic__item.dop-pic.observe
          .picture
            img(src="./pics/part-2/part-2-1.webp")


      .main-block.layer-trigger.observe.trigger-2(
        data-trigger="2",
        data-lax-preset="lazy-200"
      )
      .main-block.horizontal-content.horizontal-content-3(ref='life-style')
        Roller(:count="12", :type="1")
        .main-block__content
          h2.title-big.title-observe.observe
            .title__part
              span L
              span I
              span F
              span E
            .title__part
              span S
              span T
              span Y
              span L
              span E
          .description__area
            .description.observe
              span.count 003
              .description__part
                .p-1.text.text-observe
                  p Originally, the building was the Chrysler Corporation's headquarters with
                  p a luxurious two-storey private residence of its founder. An automobile
                  p showroom was located on the first two floors. Up to 1945 the public
                  p could access Celestial, an observation deck on the 71st floor.
                  p It was beautifully ornamented with motifs of cosmos, stars, golden
                  p rays, so for fifty cents the visitors could enjoy stunning
                  p views of New York City in a congenial atmosphere.

                .p-1.text.mobile Originally, the building was the Chrysler Corporation's headquarters with a luxurious two-storey private residence of its founder. An automobile showroom was located on the first two floors. Up to 1945 the public could access Celestial, an observation deck on the 71st floor. It was beautifully ornamented with motifs of cosmos, stars, golden rays, so for fifty cents the visitors could enjoy stunning views of New York City in a congenial atmosphere.
            .description.observe
              .description__part
                .p-1.text.text-observe
                  p Below the observatory there was the Cloud Club, a fabulous private dining
                  p and lounge space for the crème de la crème. Initially projected for
                  p Texaco directors, the Club grew into one of the most prestigious
                  p speakeasy clubs and became a desirable place to visit for all rich men
                  p of the city. Since the very beginning Chrysler Building has been home
                  p for numerous companies and businesses, and currently it remains a pure
                  p commercial office space. The only publicly accessible place is the lobby.

                .p-1.text.mobile Below the observatory there was the Cloud Club, a fabulous private dining and lounge space for the crème de la crème. Initially projected for Texaco directors, the Club grew into one of the most prestigious speakeasy clubs and became a desirable place to visit for all rich men of the city. Since the very beginning Chrysler Building has been home for numerous companies and businesses, and currently it remains a pure commercial office space. The only publicly accessible place is the lobby.
        .pic__item.observe
          .picture
            img(src="./pics/part-3/part-3-1.webp")

      .main-block.layer-trigger.observe.trigger-3(
        data-trigger="3",
        data-lax-preset="lazy-200"
      )
      .main-block.horizontal-content.horizontal-content-4(ref='artistic')
        .main-block__content
          h2.title-3.title.title-observe.observe
            .title__part
              span A
              span R
              span T
              span I
              span S
              span T
              span I
              span C
            .title__part
              span E
              span N
              span D
              span E
              span A
              span V
              span O
              span R

          .description.observe
            span.count 004
            .description__part
              .p-1.text.text-observe
                p The Chrysler Building is an outstanding example of Art Deco architecture, the embodiment
                p of the audacity of human ambition. Large-scale manufacturing developed, and designers
                p intended to make produced objects look more aesthetically attractive. They pursued
                p creating non-traditional elegance which would reflect admiration for the modern ideas
                p of progress in a chic and sophisticated manner.  Art Deco is where art and crafts meet,
                p and the Chrysler Building has it all: a lavish mixture of clean symmetry, sleek
                p geometric shapes and curved ornamental elements, stylized sunbursts, zigzags, chevrons,
                p contrasting colours and shiny metallic details, expensive innovative and natural
                p building materials. All in the name of the glory of Chrysler automobile
                p and the mechanical era of the 1920s.

              .p-1.text.mobile The Chrysler Building is an outstanding example of Art Deco architecture, the embodiment of the audacity of human ambition. Large-scale manufacturing developed, and designers intended to make produced objects look more aesthetically attractive. They pursued creating non-traditional elegance which would reflect admiration for the modern ideas of progress in a chic and sophisticated manner.  Art Deco is where art and crafts meet, and the Chrysler Building has it all: a lavish mixture of clean symmetry, sleek geometric shapes and curved ornamental elements, stylized sunbursts, zigzags, chevrons, contrasting colours and shiny metallic details, expensive innovative and natural building materials. All in the name of the glory of Chrysler automobile and the mechanical era of the 1920s.
        .horizontal-content__pics
          .pic__item.border-pic.observe
            .picture
              img(src="./pics/part-4/part-4-1.webp")
          .pic__item.dop-pic.observe
            .picture
              img(src="./pics/part-4/part-4-2.webp")
          .decorate
        .pic__item.single-pic.observe
          .picture
            img(src="./pics/part-4/part-4-3.webp")
        .main-block__content.main-block__content--second
          h2.title-6.title.title-observe.observe
            span O
            span N
            span &nbsp
            span T
            span H
            span E
            span &nbsp
            span I
            span N
            span S
            span I
            span D
            span E

          .description.observe
            span.count 005
            .description__part
              .p-1.text.text-observe
                p The interior fully reflects the exterior of the building and goes deeper into Art Deco,
                p which made an elaborate blend of innovative solutions and luxury materials. With its smooth
                p geometric forms performed in golden and ocher tones of obscenely expensive African marble,
                p amber onyx, red granite, the lobby is arguably the most ornate lobby of the city. The ceiling
                p was painted by Edward Turnbull, and the mural called 'Transport and Human Endeavor' tells
                p the story of the workers who built the skyscraper, the story of accomplishment and
                p triumph of progress. The gorgeous elevator doors with intricate of rare woods are another
                p detail in this feast for the eyes. Dim lighting only enhances the overall impressions.

              .p-1.text.mobile The interior fully reflects the exterior of the building and goes deeper into Art Deco, which made an elaborate blend of innovative solutions and luxury materials. With its smooth geometric forms performed in golden and ocher tones of obscenely expensive African marble, amber onyx, red granite, the lobby is arguably the most ornate lobby of the city. The ceiling was painted by Edward Turnbull, and the mural called 'Transport and Human Endeavor' tells the story of the workers who built the skyscraper, the story of accomplishment and triumph of progress. The gorgeous elevator doors with intricate of rare woods are another detail in this feast for the eyes. Dim lighting only enhances the overall impressions.
      .main-block.layer-trigger.observe.trigger-4(
        data-trigger="4",
        data-lax-preset="lazy-200"
      )
      .main-block.horizontal-content.horizontal-content-5(ref='inside')
        .border-effect-trigger.observe(data-trigger)
        Building
        .main-block__content
          h2.title-3.title.title-observe.observe.uppercase
            span N
            span U
            span M
            span B
            span E
            span R
            span S
          .cells.observe
            .line-middle
            .cell.observe(v-for="cell in cells", :class="`cell-${cell.id}`")
              .count
                span.ct(v-for="ct in cell.count") {{ ct }}
                span.ct.-units(v-if="cell.units") {{ cell.units }}
              .text {{ cell.text }}
              .cell__inner
                span.line(v-for="i in 4", :class="`line-${i}`")
        .layout
          router-link(to="/gallery")
            .layout__arrow
            span GALLERY
            .layout__arrow
  .progressbar
    .mask
      .line__section
      .text.circle__link(data-trigger="0" @click="scrollByLine('new-york')") New York Legend
      .line__section
      .text.circle__link(data-trigger="1" @click="scrollByLine('architecture')") Architecture
      .line__section
      .text.circle__link(data-trigger="2" @click="scrollByLine('life-style')") Life Style
      .line__section
      .text.circle__link(data-trigger="3" @click="scrollByLine('artistic')") Artistic Endeavor
      .line__section
      .text.circle__link(data-trigger="4" @click="scrollByLine('inside')") On the Inside
      .line__section
    .line(
      :style="`clip-path:polygon(0px 0px, ${scrollValue}% 0px, ${scrollValue}% 100%, 0% 100%)`"
    )
      .line__section
      .text.circle__link(@click="scrollByLine('new-york')") New York Legend
      .line__section
      .text.circle__link(@click="scrollByLine('architecture')") Architecture
      .line__section
      .text.circle__link(@click="scrollByLine('life-style')") Life Style
      .line__section
      .text.circle__link(@click="scrollByLine('artistic')") Artistic Endeavor
      .line__section
      .text.circle__link(@click="scrollByLine('inside')") On the Inside
      .line__section
</template>

<script>
import CursorCustom from "../../components/elements/Cursor/index";
import VirtualScroll from "virtual-scroll";
import loop from "../../utils/loop";
import { triggers } from "./scripts/triggers";
import { scrollAnim } from "./scripts/scroll-anim";
import { parallax } from "./scripts/parallax";
import lax from "lax.js";
// Компоненты
import BaseView from "../../views/BaseView/index";
import Roller from "../../components/elements/Roller/index";
import BuildingSVG from "../../components/elements/BuildingSVG/index";
import Building from "../../components/blocks/Building/index";
const roundDec = (n) => Math.round(n * 100) / 100;
const lerp = (a, b, n) => (1 - n) * a + n * b;
export default {
  name: "MainAW",
  data: () => ({
    theme: "dark",
    scroll: 0,
    translate: 0,
    scrollValue: 0,
    orientation: "vertical",
    move: "",
    overlay: "none",
    appear: "main",
    scrollbar: true,
    transition: '',
    vs: null,
    layers: [
      {
        id: 2,
        src: require("./layers/1.webp"),
      },
      {
        id: 3,
        src: require("./layers/2.webp"),
      },
      {
        id: 4,
        src: require("./layers/3.webp"),
      },
      {
        id: 5,
        src: require("./layers/4.webp"),
      },
      {
        id: 6,
        src: require("./layers/5.webp"),
      },
      {
        id: 7,
      },
    ],
    scrollBarArray: [
      "New York Legend",
      "Architecture",
      "Life Style",
      "Artistic Endeavor",
      "On the Inside",
    ],
    cells: [
      {
        id: 1,
        count: [7, 7],
        text: "Floors",
      },
      {
        id: 2,
        count: ["1,", 0, 4, 6],
        units: "ft",
        text: "Height",
      },
      {
        id: 3,
        count: ["1,", 2],
        units: "mln",
        text: "sq ft floor area",
      },
      {
        id: 4,
        count: ["3,", 8],
        text: "mln bricks",
      },
      {
        id: 5,
        count: [3, 2],
        text: "Elevators",
      },
      {
        id: 6,
        count: ["$", 1, 5],
        text: "mln cost",
      },
    ],
    ratios: [],
    covers: [],
  }),
  components: {
    BaseView,
    Roller,
    CursorCustom,
    BuildingSVG,
    Building,
  },
  mounted() {
    this.start();
    scrollAnim();
  },
  beforeDestroy() {
    loop.remove("checkSmooth");
    this.vs.off(this.onScroll);
    loop.stop(true);
    this.clearCursor();
  },
  methods: {
    scrollByLine(ref){
      let section = this.$refs[ref]
      this.scroll = section.offsetLeft
      this.translate = roundDec(lerp(this.translate, this.scroll, 0.07))
      this.move = `translate3d(-${this.translate}px, 0, 0)`
    },
    clearLayers() {
      const layers = this.$el.querySelector(".layers");
      layers.classList.remove("hide");
    },
    start() {
      if (window.innerWidth > 900) {
        this.setup();
        this.$el.querySelector(".progressbar").classList.add("active");
      } else {
        this.mobileScroll();
        this.checkiOS();
      }
      this.$el.querySelector(".f-title").classList.add("show");
      this.$el.querySelector(".f-subtitle").classList.add("show");
    },
    movePage() {
      const scrollParts = this.$el.querySelectorAll(".main-block"),
        layers = this.$el.querySelector(".layers"),
        scrollStep = this.$refs.container.scrollWidth / scrollParts.length;
      layers.classList.add("hide");
      this.scroll = scrollStep * event.target.dataset.scroll;
    },
    checkiOS() {
      var iOS = ["iPad", "iPhone", "iPod"].indexOf(navigator.platform) >= 0;
      if (iOS == true) {
        this.$el.querySelector(".main").classList.add("main--ios");
      }
    },
    mobileScroll() {
      lax.setup();
      const layers = this.$el.querySelectorAll(".layer-trigger");
      for (let i = 0; i < layers.length; i++) {
        lax.addElement(layers[i]);
      }
      window.addEventListener(
        "scroll",
        function (x) {
          lax.update(window.scrollY);
        },
        false
      );
    },
    clearCursor() {
      document.querySelector(".circle-cursor--outer").remove();
      document.querySelector(".circle-cursor--inner").remove();
    },
    setup() {
      loop.start();
      this.vs = new VirtualScroll({
        mouseMultiplier: 1,
        touchMultiplier: 1,
        passive: true,
      });
      loop.add(this.checkSmooth, "checkSmooth");
      this.vs.on(this.onScroll);
    },
    onScroll(e) {
      const scroll = this.scroll + -1 * e.deltaY;
      triggers();
      this.scroll = Math.min(
        Math.max(scroll, 0),
        this.$refs.container.scrollWidth - window.innerWidth
      );
    },
    scrollBar() {
      var scrollBarWidth =
        this.scroll / (this.$refs.container.offsetWidth - window.innerWidth);
      this.scrollValue = scrollBarWidth * 100;
    },
    checkSmooth() {
      this.scrollBar();
      if (Math.round(this.scroll) !== Math.round(this.translate)) {
        this.getRatio();
        if (
          this.$el
            .querySelector(".border-effect-trigger")
            .classList.contains("animated")
        ) {
          document.querySelector(".border__right").classList.add("open");
        } else {
          document.querySelector(".border__right").classList.remove("open");
        }
        parallax(this.scroll);
        const layerList = this.$el.querySelectorAll(".layer");
        for (let i = 0; i < this.ratios.length; i++) {
          var scale = 1.5 - this.ratios[i].intersectionRatio / (1 * 2);
          var brightness = this.ratios[i].intersectionRatio;
          if (i >= 0 && i <= 6) {
            this.covers[i].style.transform = `scale(${scale})`;
            this.covers[i].style.filter = `brightness(${brightness})`;
          }
        }
        this.translate = roundDec(lerp(this.translate, this.scroll, 0.07));

        if (window.innerWidth > 900) {
          this.move = `translate3d(-${this.translate}px, 0, 0)`;
        }
      }
    },
    getRatio() {
      const triggerList = this.$el.querySelectorAll(".layer-trigger");
      const covers = this.$el.querySelectorAll(".layer");
      this.covers = covers;
      const observer = new IntersectionObserver(
        (items) => {
          items.forEach(({ target, intersectionRatio }, i) => {
            this.ratios[i] = {
              target,
              intersectionRatio,
            };
          });
        },
        {
          threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
        }
      );
      triggerList.forEach((el) => {
        observer.observe(el);
      });
    },
  },
  watch: {
    move(newValue) {
      triggers();
    }
  }
};
</script>
<style lang="sass" scoped>
@import "src/sass/general/medias"
@import "src/sass/general/variables"
@import "src/sass/general/page"
@import "src/sass/utils/progressbar"
@import "src/sass/mixins/center"
@import "src/sass/mixins/fluid"
@import "src/sass/mixins/delay"

$content-indent: 8vw
.main
  min-height: 100vh
  position: absolute
  display: flex
  z-index: 1
  top: 0
  &--ios
    position: absolute!important
  @media (max-width: $b-tablet)
    display: block
    position: static
    overflow: auto
    -webkit-overflow-scrolling: touch
    height: auto
    width: 100vw
    top: initial
    overflow-x: hidden
  &-block
    min-width: 100vw
    will-change: transform
    min-height: 100vh
    z-index: 2
    position: relative
    border-left: 1px solid $brown2
    border-right: 1px solid $brown2
    @media (max-width: $b-tablet)
      height: auto
      min-height: initial
      border-left: none
      border-right: none
      border-top: 1px solid $brown2
      border-bottom: 1px solid $brown2
    &:first-child
      display: flex
      align-items: flex-end
      h1
        margin-bottom: 20vh
        margin-left: 20vw
        display: flex
        flex-direction: column
        .title
          &:last-child
            margin-top: 20px
            margin-left: 3vw

  .main-block__title
    display: grid
    grid-gap: 30px
    @media (max-width: $b-tablet)
      grid-gap: 15px
    .title-3
      line-height: 80%

  .main-block__content
    display: grid
    grid-gap: 60px
    @media (max-width: $l-desktop)
      grid-gap: 20px
    @media (max-width: $b-tablet)
      padding: 0 45px
    @media (max-width: $b-mobile)
      padding: 0 25px
    .text.mobile
      display: none!important
      @media (max-width: $b-tablet)
        display: inline-block!important
        margin-right: 5px
        font-size: 16px
      p
        @media (max-width: $b-tablet)
          opacity: 1
          transform: none
          display: none

    .title
      @media (max-width: $b-tablet)
        transition-duration: .5s
        opacity: 0
        transform: translateY(40px)
      @media (max-width: $b-mobile)
        text-transform: uppercase
        letter-spacing: 0px
      span
        @media (max-width: $b-tablet)
          opacity: 1
          transform: none
    .description
      display: flex
      grid-gap: 70px
      @media (max-width: $b-tablet)
        flex-direction: сolumn
        grid-gap: 0px
        position: relative
      &__part
        @media (max-width: $b-tablet)
          transition-duration: .5s
          transform: translateY(40px)
          opacity: 0
          transition-delay: .2s
        .text
          margin: 0
          display: flex
          flex-direction: column
          &.text-observe
            @media (max-width: $b-tablet)
              display: none
      .count
        color: $gold
        line-height: 2
        letter-spacing: 1px
        font-size: 10px
        font-family: 'Futura PT Book'
        @media (max-width: $b-tablet)
          transition-duration: .5s
          transform: translateY(40px)
          opacity: 0
          margin-right: 20px
      .link
        transition-duration: .4s
        opacity: 0
        transition-delay: .5s
        margin-top: 50px
        @media (max-width: $b-tablet)
          opacity: 1
          margin-top: 35px
          margin-left: 4px
          padding: 17px 35px
      p
        max-width: 450px
    .quote
      margin-top: 30px

.layers.hide
  &:before
    content: ''
    position: absolute
    top: 0
    left: 0
    width: 100%
    height: 100%
    background: #1D1A1B
.layers
  position: fixed
  width: 100vw
  height: 100vh
  z-index: 1
  top: 0
  left: 0
  transition-duration: .3s
  .layer
    width: inherit
    height: inherit
    position: absolute
    background-position: center
    will-change: transform
    top: 0
    background-size: 100%
    opacity: 0
    left: 0
    background-repeate: no-repeate
    @media (max-width: $m-desktop)
      background-position: center
      background-size: 110%
    @media (max-width: $sm-desktop)
      background-size: 125%
    @media (max-width: $b-tablet)
      background-size: cover
  .f-layer
    opacity: 1
    grid-gap: 20px
    +center-flex
    flex-direction: column
    h1
      +mainTitle
      color: $gold
      font-weight: 300
      font-family: 'Baza'
  .f-title, .f-subtitle
    overflow-y: hidden
    overflow-x: visible
    margin: 0
    line-height: 0.82
    span
      text-rendering: optimizeLegibility
      -webkit-font-smoothing: antialiased
      transform: translateY(100%)
      transition-timing-function: ease
      display: inline-block
      transition-duration: 1s
      @include delay(transition, 8, 0.1s)
  .show
    transition-duration: .7s
    span
      transform: translateY(0)
      opacity: 1
  .fade
    span
      transform: translateY(-100%)
      opacity: 0

  .f-subtitle
    font-size: 32px
    color: $gold
    font-weight: 300
    font-family: 'Baza'
    span
      margin: 0 3px

.layer-trigger
  background-size: cover
  z-index: 1
  will-change: transform
  @media (max-width: $b-tablet)
    height: auto
    min-height: 100vh
    margin-top: -20vh
    transform: scale(1.1)
  &:first-child
    margin: 0

.layer__bg
  position: absolute
  margin: auto
  right: 0
  left: 0
  display: flex
  justify-content: center
  z-index: -1
  bottom: -46vh
  @media (max-width: $b-tablet)
    bottom: initial
    width: 80%

.trigger
  &-1
    @media (max-width: $b-tablet)
      background-image: url(./layers/1.webp)
      background-position: bottom
  &-2
    width: 70vw
    @media (max-width: $b-tablet)
      background-image: url(./layers/2.webp)
      background-position: right
  &-3
    width: 60vw
    @media (max-width: $b-tablet)
      background-image: url(./layers/3.webp)
      background-position: top
  &-4
    @media (max-width: $b-tablet)
      background-image: url(./layers/4.webp)
.horizontal-content__pics
  position: relative
  @media (max-width: $b-tablet)
    margin-top: 55px
.pic__item
  transition-duration: .2s
  @media (max-width: $b-tablet)
    transition-duration: .6s
    transform: translateY(40px)
    opacity: 0
    transition-delay: .2s
  .picture
    overflow: hidden
    position: relative
    height: 100%
    width: 100%
    img
      margin-left: -25px
      transition-duration: .2s
      width: calc(100% + 50px)
      display: block
.dop-pic
  position: absolute
  @media (max-width: $b-tablet)
    position: static
.border-pic
  position: relative
  &:before
    content: ''
    position: absolute
    top: 30px
    left: -30px
    width: 100%
    height: 100%
    border: 1px solid $brown2
  @media (max-width: $b-tablet)
    &:before
      display: none

.decorate
  position: absolute
  height: 100vh
  width: 50%
  top: 0
  z-index: -1!important
  will-change: transform
  left: 0
  right: 0
  margin: auto
  background-size: cover
  background-image: url(./pics/part-4/decorate.svg)
  @media (max-width: $b-tablet)
    height: auto

$cell: 180px
$cell-m: 150px
$cell-s: 140px
.cells
  display: flex
  z-index: 2
  position: relative
  @media (max-width: $b-tablet)
    width: max-content
  @media (max-width: $s-tablet)
    flex-wrap: wrap
    width: calc(100vw - 45px)
    padding-right: 45px
  @media (max-width: $b-mobile)
    padding-right: 0
  .line-middle
    margin-top: calc(#{$cell} - 0px)
    position: absolute
    background: $brown2
    height: 1px
    width: 100%
    transform: scaleX(0) translateZ(0)
    //transition-delay: .2s
    transition-duration: .4s
    transition-timing-function: cubic-bezier(.165,.84,.44,1)
    transform-origin: right
    @media (max-width: $m-desktop)
      margin-top: calc(#{$cell-m} - 0px)
    @media (max-width: $s-desktop)
      margin-top: calc(#{$cell-s} - 0px)
  .cell
    width: $cell
    height: $cell
    display: flex
    +center-flex
    position: relative
    text-align: center
    flex-direction: column
    padding: 0 20px
    @media (max-width: $m-desktop)
      width: $cell-m
      height: $cell-m
    @media (max-width: $s-desktop)
      width: $cell-s
      height: $cell-s
    @media (max-width: $s-tablet)
      width: 50%
      border: 1px solid $brown2
    &-1
      .cell__inner
        .line-3
          transition-delay: .4s
        .line-2
          height: 200%
          transition-duration: .2s
          transition-delay: .6s
        .line-1
          transition-delay: .5s
    &-2
      .cell__inner
        .line-2
          height: 200%
          bottom: 0
          top: initial
          transition-duration: .2s
          transition-delay: .8s
          transform-origin: bottom
        .line-3
          display: none
        .line-4
          transition-delay: .7s
    &-3
      .cell__inner
        .line-3
          display: none
        .line-1
          transition-delay: .9s
        .line-2
          height: 200%
          transition-delay: .8s
    &-4
      .cell__inner
        .line-3
          display: none
        .line-4
          transition-delay: 1.2s
        .line-2
          bottom: 0
          transform-origin: bottom
          top: initial
          transition-duration: .2s
          height: 200%
          transition-delay: 1.3s
    &-5

      .cell__inner
        .line-3
          display: none
        .line-1
          transition-delay: 1.5s
        .line-2
          transition-delay: 1.6s
    &__inner
      position: absolute
      width: 100%
      height: 100%
      +center
      @media (max-width: $s-tablet)
        display: none
      .line
        position: absolute
        background: $brown2
        transition-duration: .1s
        transition-timing-function: linear
        &-1
          top: 0
          width: 100%
          height: 1px
          transform: scaleX(0) translateZ(0)
          transform-origin: left
          left: 0
        &-2
          top: 0
          width: 1px
          height: 100%
          right: 0
          transform-origin: top
          transform: scaleY(0) translateZ(0)
        &-3
          bottom: 0
          width: 1px
          height: 100%
          left: 0
          transform: scaleY(0) translateZ(0)
          transform-origin: bottom
        &-4
          bottom: 0
          width: 100%
          height: 1px
          left: 0
          transform-origin: left
          transform: scaleX(0) translateZ(0)
    &:nth-child(odd)
      margin-top: calc(#{$cell} - 0px)
      margin-left: -1px
      margin-right: -1px
      @media (max-width: $m-desktop)
        margin-top: calc(#{$cell-m} - 0px)
      @media (max-width: $s-desktop)
        margin-top: calc(#{$cell-s} - 0px)
      @media (max-width: $s-tablet)
        margin: 0 -2px -2px calc(50% -1px)
    .count
      color: $gold
      font-family: 'Futura Light'
      font-size: 50px
      font-weight: 100
      overflow: hidden
      white-space: nowrap
      @media (max-width: $b-tablet)
        font-size: 48px
      .ct
        transition-duration: .7s
        display: inline-block
        transform: translateY(105%) translateZ(0)
        transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1)
        @media (max-width: $b-tablet)
          transition-delay: 0s!important
        &:nth-child(1)
          transition-delay: .7s
        &:nth-child(2)
          transition-delay: .75s
        &:nth-child(3)
          transition-delay: .8s
        &:nth-child(4)
          transition-delay: .9s
        &:nth-child(5)
          transition-delay: 1s
      .ct.-units
        margin-left: .2em
        font-size: .6em
    .text
      font-family: 'Futura PT Book'
      color: rgba(255,255,255,.6)
      font-size: 13px
      transition-delay: 1s
      opacity: 0
      transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1)
      transition-duration: .7s
      @media (max-width: $b-tablet)
        transition-delay: .4s!important

.cells.animated
  .line-middle
    @media (max-width: $s-tablet)
      display: none
      transform: scaleX(1) translateZ(0)
  .cell
    .cell__inner
      .line-1
        transform: scaleX(1) translateZ(0)
      .line-2
        transform: scaleY(1) translateZ(0)
      .line-3
        transform: scaleY(1) translateZ(0)
      .line-4
        transform: scaleX(1) translateZ(0)
.cell.animated
  .text
    opacity: 1
  .count
    .ct
      transform: translateY(0) translateZ(0)
.page
  transform: none!important

.horizontal-content
  background: $brown
  width: 110vw
  display: flex
  align-items: center
  padding: 0 9vw
  @media (max-width: $m-desktop)
    padding: 0 5vw
  @media (max-width: $s-desktop)
    width: 125vw
  @media (max-width: $b-tablet)
    width: 100vw
    display: block
    padding: 65px 0 95px
    height: auto
  &-1
    justify-content: space-between
    @media (max-width: $b-tablet)
      display: flex
      grid-gap: 0px
      flex-direction: column-reverse
      &:before
        content: ''
        height: 40vh
        width: 100%
        position: absolute
        top: -40vh
        background: linear-gradient(to top, $brown 10%, transparent)
      .main-block__content
        margin-top: 50px

    .roller
      left: 40%
      top: 25vh
    .pic__item
      &:first-child
        height: 70vh
        width: 25vw
        margin-top: -10vh
        z-index: 2
        @media (max-width: $b-tablet)
          width: 100%
          margin: 0px 0 0 0px
          height: 80vh
          z-index: 0
          padding-left: 85px
        @media (max-width: $b-mobile)
          padding-left: 65px
    .dop-pic
      width: 24vw
      bottom: -12vh
      left: -10vw
      z-index: 1
      @media (max-width: $b-tablet)
        left: 0
        bottom: initial
        width: 70vw
        margin-top: -15vh
    .title-3
      @media (max-width: $b-tablet)
        font-size: 50px
        margin-bottom: 0
  &-2
    justify-content: flex-start
    .main-block__content
      width: 80%
      @media (max-width: $b-tablet)
        width: 100%
    .title-5
      @media (max-width: $b-tablet)
        margin-bottom: 50px
        font-size: 20px
        opacity: 1!important
        margin-top: -30px
    .roller
      right: 8vw
      top: 12vh
    .map
      width: 35vw
      height: 80vh
      margin-right: $content-indent
      @media (max-width: $b-tablet)
        display: none
      img
        width: 100%
        object-fit: cover
    .dop-pic
      width: 22vw
      height: 62vh
      position: absolute
      right: -8vw
      bottom: 10vh
      @media (max-width: $b-tablet)
        right: initial
        left: 0
        width: 50vw
        height: 70vh
        bottom: -64vh
      img
        background-position: center bottom
    .link
      @media (max-width: $b-tablet)
        display: none
  &-3
    justify-content: space-between
    @media (max-width: $b-tablet)
      display: flex!important
      flex-direction: column-reverse
      z-index: 3
    .roller
      left: 60vw
      top: 17vh
    .link
      @media (max-width: $b-tablet)
        display: none
    .pic__item
      z-index: 1
      position: absolute
      margin: auto
      right: -7vw
      @media (max-width: $b-tablet)
        left: 0
        right: initial
        width: calc(100vw - 67px)
        bottom: -100vh
    .title-big
      @media (max-width: $b-tablet)
        font-size: 72px
  &-4
    width: 125vw
    @media (max-width: $l-desktop)
      width: 135vw
    @media (max-width: $b-tablet)
      display: flex!important
      flex-direction: column
      width: 100vw
      padding: 230px 0 95px
    .decorate
      @media (max-width: $b-tablet)
        height: calc(100% + 400px)
        top: -200px
        left: 0
        width: 60vw
        right: initial
        &:before
          content: ''
          height: 30%
          width: 100%
          position: absolute
          top: 0
          background: linear-gradient(to bottom, $brown, transparent)
        &:after
          content: ''
          height: 20%
          width: 100%
          position: absolute
          bottom: 0
          background: linear-gradient(to top, $brown, transparent)
    .link
      @media (max-width: $b-tablet)
        display: none
    .single-pic
      position: absolute
      right: -10vw
      width: 33vw
      top: 0
      height: 45vh
      @media (max-width: $b-tablet)
        height: 30vh
        right: 0
        left: initial
        top: initial
        bottom: -22vh
        width: calc(100vw - 67px)
    .main-block__content
      &:first-child
        margin-right: 7vw
        @media (max-width: $b-tablet)
          margin-right: 0
      &:last-child
        grid-gap: 25px
        margin-top: 20vh
        margin-left: 7vw
        margin-right: 7vw
        @media (max-width: $b-tablet)
          margin: 150px 0 0
    .horizontal-content__pics
      margin-right: $content-indent
      height: 100%
      @media (max-width: $b-tablet)
        width: 100%
        height: initial
        margin: 70px 0 0
        padding-left: 0
      .pic__item
        &:nth-child(1)
          height: 80vh
          margin-top: 8vh
          z-index: 0
          width: 22vw
          @media (max-width: $b-tablet)
            width: calc(100vw - 67px)
            margin: 0
            height: 70vh
          &:before
            left: initial
            right: -30px
        &:nth-child(2)
          width: 22vw
          height: 28vh
          right: -38%
          z-index: 2
          filter: brightness(70%)
          bottom: 10vh
          @media (max-width: $b-tablet)
            bottom: -12vh
            right: 0
            left: initial
            width: calc(100vw - 67px)
            position: absolute
            filter: brightness(100%)
  &-5
    width: auto!important
    padding-right: 0!important
    @media (max-width: $l-desktop)
      width: 160vw!important
    @media (max-width: $s-desktop)
      width: 200vw!important
    .main-block__content
      padding-right: 7vw
    .building
      @media (max-width: $b-tablet)
        height: 100vh
        width: 100vw
        margin: 0 0 150px
        &:before
          content: ''
          height: 30%
          width: 100%
          position: absolute
          bottom: 0
          z-index: 1

          background: linear-gradient(to top, $brown, transparent)
          pointer-events: none
    .building__picture svg g
      opacity: 1
    .layout
      display: none
      @media (max-width: $b-tablet)
        margin: 80px 0 20px
        display: block
        a
          color: $gold
          text-transform: uppercase
          font-family: 'Baza'
          width: 100vw
          letter-spacing: 2px
          display: flex
          align-items: center
          font-size: 40px
          justify-content: space-between
        &__arrow
          height: 1px
          content: ''
          position: relative
          width: 45px
          background: $brown2
          &:before
            width: 6px
            height: 6px
            display: block
            position: absolute
            top: 0
            bottom: 0
            content: ''
            margin: auto
            border-top: 1px solid $brown2
            border-right: 1px solid $brown2
          &:first-child:before
            right: 0
            transform: rotate(45deg)
          &:last-child:before
            left: 0
            transform: rotate(-135deg)
    .border-effect-trigger
      position: absolute
      right: 10vw
      height: 100%

.description.animated
  .count
    @media (max-width: $b-tablet)
      transform: translateY(0)!important
      opacity: 1!important
      transition-delay: .1s
    .link
      opacity: 1!important
  .description__part
    @media (max-width: $b-tablet)
      transform: translateY(0)!important
      opacity: 1!important
      transition-delay: .2s
.title.animated
  @media (max-width: $b-tablet)
    opacity: 1!important
    transform: translateY(0)!important
    transition-delay: .2s
.pic__item.animated
  @media (max-width: $b-tablet)
    transform: translateY(0px)!important
    opacity: 1!important

.description__area
  display: flex
  grid-gap: 60px
  @media (max-width: $b-tablet)
    grid-gap: 20px
    flex-direction: column
</style>
